import React from 'react';
import { Switch } from 'react-router-dom';

import { AUTHORITIES } from 'app/config/constants';
import PrivateRoute from 'app/shared/auth/private-route';
import FavoriteTruck from './favorite-truck';
import FavoriteTruckDeleteDialog from './favorite-truck-delete-dialog';
import FavoriteTruckDetail from './favorite-truck-detail';
import FavoriteTruckUpdate from './favorite-truck-update';

const Routes = ({ match }) => (
  <>
    <Switch>
      <PrivateRoute exact path={`${match.url}/new`} component={FavoriteTruckUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id/edit`} component={FavoriteTruckUpdate} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute exact path={`${match.url}/:id`} component={FavoriteTruckDetail} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
      <PrivateRoute path={match.url} component={FavoriteTruck} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
    </Switch>
    <PrivateRoute exact path={`${match.url}/:id/delete`} component={FavoriteTruckDeleteDialog} hasAnyAuthorities={[AUTHORITIES.ADMIN]} />
  </>
);

export default Routes;
